/**
 * @desc 根据平台订单号查询是否有退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: ObjectMap<any, object>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/returnOrderList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
